import { Dictionary } from '@hkm/shared/dictionaries/dictionary';

export const HousekeepingStatisticsDictionaries: Set<Dictionary> = new Set<Dictionary>()
  .add(Dictionary.RoomStatus);



// WEBPACK FOOTER //
// ./src/components/Housekeeping/Statistics/config/housekeepingStatisticsDictionaries.ts